import {
  Button,
  ControlGroup,
  InputGroup,
  NumericInput,
  Tag,
} from "@blueprintjs/core";
import _ from "lodash";
import { nanoid } from "nanoid";
import React from "react";
import { compareTwoObjects } from "../fns/util";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";

class ArrayStringContentMaster extends React.Component {
  state = {
    changed: false,
    contents: [],
    inputValue: "",
    isEditingPanelRepetition: false,
    priceStaggering: [],
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  renderAll = () => {
    let s = this.state.contents;
    if (!s.length) {
      return (
        <ControlGroup>
          <Tag minimal large>
            No{" "}
            {this.props.indexContentName
              ? this.props.indexContentName
              : this.props.displayTitle}
            s added.
          </Tag>
        </ControlGroup>
      );
    }

    return s.map((each, ix) => {
      return (
        <ControlGroup>
          <Tag
            large
            minimal
            interactive
            onRemove={() => {
              let list = this.state.contents;

              let which = _.findIndex(list, (x) => x.nanoid === each.nanoid);
              list.splice(which, 1);
              this.setState({ changed: true, contents: list }, () =>
                this.props.onUpdate(
                  compareTwoObjects(this.state, this.props.data)
                )
              );
            }}
          >
            {this.props.indexContentName
              ? this.props.indexContentName
              : this.props.displayTitle}{" "}
            {ix + 1}
          </Tag>
          {this.renderEach(each)}
        </ControlGroup>
      );
    });
  };
  renderEach = (eachContent) => {
    return (
      <InputGroup
        fill
        value={eachContent.text}
        onChange={(event) => {
          let newText = event.target.value;

          let list = this.state.contents;

          let which = _.findIndex(list, (x) => x.nanoid === eachContent.nanoid);
          list[which].text = newText;

          this.setState({ changed: true, contents: list }, () =>
            this.props.onUpdate(compareTwoObjects(this.state, this.props.data))
          );
        }}
      />
    );
  };
  renderSiteSelector = () => {
    if (this.props.entityType === "sxOTMaster") {
      return (
        <div>
          <ControlGroup>
            <SingleSelectWrapper
              items={this.props.sites}
              selectedItem={this.state.site}
              onChange={(item) =>
                this.setState({ site: item, changed: true }, () =>
                  this.props.onUpdate(
                    compareTwoObjects(this.state, this.props.data)
                  )
                )
              }
            />
          </ControlGroup>
          <br />
        </div>
      );
    } else {
      return null;
    }
  };
  handleRemove = (index) => {
    const updatedPriceStaggering = [...this.state.priceStaggering];
    updatedPriceStaggering.splice(index, 1);
    this.setState({ priceStaggering: updatedPriceStaggering }, () => {
      this.props.onUpdate(compareTwoObjects(this.state, this.props.data));
    });
  };
  handleSave = () => {
    const { inputValue } = this.state;
    if (!isNaN(inputValue)) {
      this.setState(
        {
          priceStaggering: [...this.state.priceStaggering, inputValue],
          changed: true,
          inputValue: "",
          isEditingPanelRepetition: false,
        },
        () =>
          this.props.onUpdate(compareTwoObjects(this.state, this.props.data))
      );
    }
  };
  render() {
    if (this.props.entityType === "sxDischargeTemplateMaster") {
      return null;
    } else {
      return (
        <div className="card__top__bottom__space">
          {this.renderSiteSelector()}
          <ControlGroup>
            <Tag intent="primary" large>
              List of{" "}
              {this.props.indexContentName
                ? this.props.indexContentName
                : this.props.displayTitle}
              s
            </Tag>
            <Tag minimal>
              Please enter the list of{" "}
              {this.props.indexContentName
                ? this.props.indexContentName
                : this.props.displayTitle}
              s below.
            </Tag>
            <Button
              icon="add"
              text={`Add New ${
                this.props.indexContentName
                  ? this.props.indexContentName
                  : this.props.displayTitle
              }`}
              onClick={() => {
                let s = this.state.contents;
                let newContent = {
                  nanoid: nanoid(),
                  text: `Please enter ${
                    this.props.indexContentName
                      ? this.props.indexContentName
                      : this.props.displayTitle
                  }.`,
                };
                s = [...s, newContent];
                this.setState({ changed: true, contents: s }, () =>
                  this.props.onUpdate(
                    compareTwoObjects(this.state, this.props.data)
                  )
                );
              }}
            />
          </ControlGroup>
          <br />
          {this.renderAll()}
          {this.props.isCashless ? (
            <ControlGroup style={{ marginTop: "20px" }}>
              <Tag intent="primary" large>
                Price Staggering
              </Tag>
              {this.state.isEditingPanelRepetition ? (
                <ControlGroup>
                  <ControlGroup>
                    <NumericInput
                      style={{ width: "9em" }}
                      value={this.state.inputValue}
                      buttonPosition="NONE"
                      onValueChange={(number) =>
                        this.setState({ inputValue: number })
                      }
                    />
                    <Button
                      disabled={!this.state.inputValue}
                      icon="tick-circle"
                      minimal
                      onClick={this.handleSave}
                    />
                  </ControlGroup>
                  <ControlGroup style={{ width: "fit-content" }}>
                    {this.state.priceStaggering.length > 0
                      ? this.state.priceStaggering.map((number, index) => (
                          <Tag
                            key={index}
                            minimal
                            intent="primary"
                            multiline
                            style={{
                              marginRight: "5px",
                              justifyContent: "center",
                            }}
                          >
                            {number}
                            <Button
                              icon="cross"
                              minimal
                              onClick={() => this.handleRemove(index)}
                              style={{ marginLeft: "5px" }}
                            />
                          </Tag>
                        ))
                      : null}
                  </ControlGroup>
                </ControlGroup>
              ) : (
                <ControlGroup style={{ width: "fit-content" }}>
                  <Button
                    minimal
                    icon="edit"
                    onClick={() =>
                      this.setState({ isEditingPanelRepetition: true })
                    }
                  />
                  {this.props.data.priceStaggering &&
                  this.props.data.priceStaggering.length > 0
                    ? this.props.data.priceStaggering.map((number, index) => (
                        <Tag
                          key={index}
                          minimal
                          intent="primary"
                          multiline
                          style={{ marginRight: "5px" }}
                        >
                          {number}
                          <Button
                            icon="cross"
                            minimal
                            onClick={() => this.handleRemove(index)}
                            style={{ marginLeft: "5px" }}
                          />
                        </Tag>
                      ))
                    : null}
                </ControlGroup>
              )}
            </ControlGroup>
          ) : null}
        </div>
      );
    }
  }
}

export default ArrayStringContentMaster;
